import { Track, StoreUserIdentifier } from './actions/analyticsManager.actions';
import middleware from './middlewares/analyticsManager.middleware';
import AnalyticsReducer from './reducers/analyticsManager.reducer';
import * as trackers from './trackers';
import * as onetrust from './tracking/onetrust';
import AnalyticsManager from './AnalyticsManager';

export {
  AnalyticsManager,
  middleware as analyticsMiddleware,
  AnalyticsReducer,
  onetrust,
  StoreUserIdentifier,
  Track,
  trackers,
};
try {
    // @ts-ignore
    middleware.displayName = "middleware";
    // @ts-ignore
    middleware.__docgenInfo = { "description": "", "displayName": "middleware", "props": { "getState": { "defaultValue": null, "description": "", "name": "getState", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/analyticsManager/index.ts#middleware"] = { docgenInfo: middleware.__docgenInfo, name: "middleware", path: "src/shared/analyticsManager/index.ts#middleware" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    StoreUserIdentifier.displayName = "StoreUserIdentifier";
    // @ts-ignore
    StoreUserIdentifier.__docgenInfo = { "description": "", "displayName": "StoreUserIdentifier", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/analyticsManager/index.ts#StoreUserIdentifier"] = { docgenInfo: StoreUserIdentifier.__docgenInfo, name: "StoreUserIdentifier", path: "src/shared/analyticsManager/index.ts#StoreUserIdentifier" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    Track.displayName = "Track";
    // @ts-ignore
    Track.__docgenInfo = { "description": "", "displayName": "Track", "props": { "event": { "defaultValue": null, "description": "", "name": "event", "required": true, "type": { "name": "string" } }, "params": { "defaultValue": null, "description": "", "name": "params", "required": false, "type": { "name": "{}" } }, "vendor": { "defaultValue": null, "description": "", "name": "vendor", "required": false, "type": { "name": "TrackingVendor" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/analyticsManager/index.ts#Track"] = { docgenInfo: Track.__docgenInfo, name: "Track", path: "src/shared/analyticsManager/index.ts#Track" };
}
catch (__react_docgen_typescript_loader_error) { }